// ============================================================
// Print Export Types — paper geometry + rendered pages
// ============================================================

export type PaperSize = "A4" | "A5" | "A6" | "Letter" | "Legal" | "Thermal80" | "Custom";

export type Orientation = "portrait" | "landscape";

/** Custom paper dimensions in mm (used when paperSize === "Custom"). */
export interface CustomPaperMm {
  width: number;
  height: number;
}

export interface PaperDimensions {
  size: PaperSize;
  /** Width in mm */
  width: number;
  /** Height in mm */
  height: number;
  /** Scale: 1px = scale mm (A4 at 96dpi ≈ 0.264583) */
  scale: number;
}

export const PAPER_DIMENSIONS: Record<PaperSize, PaperDimensions> = {
  A4: { size: "A4", width: 210, height: 297, scale: 0.264583 },
  A5: { size: "A5", width: 148, height: 210, scale: 0.264583 },
  A6: { size: "A6", width: 105, height: 148, scale: 0.264583 },
  Letter: { size: "Letter", width: 216, height: 279, scale: 0.264583 },
  Legal: { size: "Legal", width: 216, height: 356, scale: 0.264583 },
  // 80mm thermal receipt printers (POS / mini). Height follows the longest
  // common roll segment; users can pick Custom for other roll lengths.
  Thermal80: { size: "Thermal80", width: 80, height: 297, scale: 0.264583 },
  // Placeholder — real dimensions come from CustomPaperMm at call time.
  Custom: { size: "Custom", width: 100, height: 150, scale: 0.264583 },
};

/** One physical output page: a `<section class="docx">` rendered to HTML. */
export interface RenderedPage {
  pageIndex: number;
  /** Filled HTML ready for html2canvas / print */
  html: string;
  /** For internal tracking */
  rowIndex: number;
  templatePageIndex: number;
  paperSize?: PaperSize;
  orientation?: Orientation;
  /** True when the rendered content is taller than the physical page. */
  overflow?: boolean;
}
